import PropTypes from "prop-types";
import Breadcrumbs from "@/components/layout/breadcrumbs.jsx";

PageHeader.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  links: PropTypes.array,
  className: PropTypes.string,
  subtitle: PropTypes.string,
};

export default function PageHeader({ links, name, description, subtitle, className = "-mt-2" }) {
  let breadcrumbBlock, descriptionBlock, subtitleBlock;

  if (links && links.length > 0) {
    breadcrumbBlock = (
      <div>
        <Breadcrumbs links={links} />
      </div>
    );
  }

  if (description && description.length > 0) {
    descriptionBlock = <p className="pb-6 pt-2">{description}</p>;
  }

  if (subtitle && subtitle.length > 0) {
    subtitleBlock = <h2 className="text-2xl text-neutral-600">{subtitle}</h2>;
  }

  return (
    <div className={className}>
      {breadcrumbBlock}
      <h1 className="text-4xl font-extrabold">{name}</h1>
      {subtitleBlock}
      {descriptionBlock}
    </div>
  );
}
